export default {
  EVENTS_ADD_ONS_SOLD: 'Add-ons Sold',
  EVENTS_GO_TO_ATTENDEE_LIST_REPORT:
    'Go to detailed report of your event’s <link>attendees list</link>.',
  EVENTS_SALES: 'Sales: {amount}',
  EVENTS_TICKETS_SOLD: 'Tickets Sold',
  EVENTS_TICKETS_SOLD_FREE: 'Free {count}',
  EVENTS_TICKETS_SOLD_PAID: 'Paid {count}',
  EVENT_NAME: 'Event Name',
  FAIR_MARKET_VALUE_TOTAL: 'Total Fair Market Value',
  NUMBER_TICKETS_PURCHASED: '# Tickets Purchased',
};
